import React from 'react';

const jQuery = window.$;

export const limitSentence = (string, num) => {
  let array = string.split('.');
  return array[num];
};

export const formatFilter = (string) => {
  return string.replace('-', ' ');
};

export const generateAnchor = (title, url) => {
  return <a href={url} target="_blank" rel="noopener noreferrer">{title}</a>;
};

// form utils
export const doHandleSuccess = (btn, modal, title, message = '') => {
  toggleButton(btn, true);
  if(modal) {
    jQuery('#title-p').html(title);
    jQuery('#msg-p').html(message);
    jQuery('#centralModalSuccess').modal('show');
  }
};

export const doHandleErrors = (err, btn, title, message = 'A problem has occurred. Please try again later.') => {
  let server_msg = 'A problem has occurred. Please try again later.';
  if (err.response) {
    // console.log(err.response);
    if (err.response.status === 500) {
      message = server_msg;
    }
  }
  else {
    message = server_msg;
  }

  toggleButton(btn, true);
  jQuery('#title-pe').html(title);
  jQuery('#msg-pe').html(message);
  jQuery('#centralModalDanger').modal('show');
};

export const runValidationCheck = (validation, formErrors) => {
  let newErrors = formErrors;
  Object.keys(validation).forEach((field) => {
    const result = checkField(field, validation[field], newErrors);
    formErrors = { ...formErrors, ...result };
  });

  return newErrors;
};

export const checkValidation = (validation, formErrors) => {
  let isValid = true;
  Object.keys(validation).forEach((field) => {
    // '' means there is no input
    if (validation[field] === '') {
      isValid = false;
    }
  });

  Object.keys(formErrors).forEach((field) => {
    // if NOT empty string, there is an error
    if (validation.formErrors[field] !== '') {
      isValid = false;
    }
  });

  return isValid;
};


export const checkField = (name, value, formErrors) => {
  let fieldValidationErrors = formErrors;
  let valid;

  switch(name) {
    case 'email':
      valid = checkEmail(value);
      fieldValidationErrors[name] = valid ? '' : 'Please enter a valid email address';
      break;

    case 'firstname':
      valid = minimumLength(value, 2);
      fieldValidationErrors[name] = valid ? '' : 'Please enter your first name';
      break;

    case 'lastname':
      valid = minimumLength(value, 2);
      fieldValidationErrors[name] = valid ? '' : 'Please enter your last name';
      break;

    case 'msg':
      valid = minimumLength(value, 3);
      fieldValidationErrors[name] = valid ? '' : 'Please enter your message';
      break;

    // case 'phone':
    //   valid = minimumLength(value, 4);
    //   if(valid) {
    //     valid = isNumeric(value);
    //   }

    //   fieldValidationErrors[name] = valid ? '' : 'Please enter a valid phone number';
    //   break;

    default:
      break;
  }

  return { formErrors: fieldValidationErrors };
}

const minimumLength = (text, min) => {
  return text.trim().length >= min;
};

const checkEmail = (value) => {
  return value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
};

// const isNumeric = (value) => {
//   const regex=/^[0-9]+$/;
//   return value.match(regex);
// };

export const toggleButton = ({ id, txt }, status) => {
  if(status) {
    jQuery(id).html(txt);
    jQuery(id).removeAttr('disabled');
  }
  else {
    jQuery(id).html("Sending...");
    jQuery(id).attr('disabled', 'disabled');
  }
};

export const passwordValid = (value) => {
  let valid = minimumLength(value, 7);
  if(valid) {
    valid = passwordValidator(value);
  }
  return valid;
};

export const passwordValidator = (value) => {
   return /^[A-Za-z0-9\d$@$!%*?&^<>()]*$/.test(value) // consists of only these
       && /[A-Z]/.test(value) // has an uppercase letter
       && /\d/.test(value) // has a digit
};
